import React from 'react';
import './Services.css';

const Services = ({ t }) => {
  return (
    <section id="services" className="services">
      <div className="section-header">
        <h2 className="section-title">{t.services.title}</h2>
        <p className="section-subtitle">{t.services.subtitle}</p>
      </div>
      <div className="services-grid">
        {t.services.items.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
